<template>
  <div v-if="true">
    <div class="form-group row">
      <div class="col-md-12 pt-1">
        <h5 class="text-third">
          <i class="fa fa-user-plus"></i> Usuários
        </h5>
      </div>
    </div>
    <div class="form-group row">
      <div
        class="col-md-5"
        style="overflow-y: auto; max-height:40vh"
      >
        <table
          class="table table-hover"
          style="border: 1px solid #dcdede;"
        >
          <thead
            class="thead-third"
            style="border: solid 1px #0277bd; height: 44px;"
          >
            <tr>
              <th class="text-center col-1"><input type="checkbox" v-model="selectAllLeftTable"></th>
              <th class="text-center">Nome</th>
            </tr>
          </thead>
          <tr
            v-for="usuario in usersList"
            :key="usuario.id"
          >
            <td
              v-if="allSelectedLeftTable"
              class="text-center col-1"
            >
              <input
                v-model="allSelectedLeftTable"
                type="checkbox"
                checked
                disabled />
            </td>
            <td
              v-else
              class="text-center col-1"
            >
              <input
                v-model="selectedUserListLeftTable"
                :value="usuario.id"
                type="checkbox" />
            </td>
            <td class="text-center">{{usuario.username}}</td>
          </tr>
        </table>
      </div>

      <div class="d-flex flex-column col-md-2 align-self-center align-items-center">
        <div class="pb-3">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="moveToRight()"
            v-b-tooltip.hover
          >
            <i class="fas fa-arrow-right"></i> <span class="d-md-down-none"></span>
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            v-on:click="moveToLeft()"
            v-b-tooltip.hover
          >
            <i class="fas fa-arrow-left"></i> <span class="d-md-down-none"></span>
          </button>
        </div>
      </div>

      <div class="col-md-5" style="overflow-y: auto; max-height:40vh">
        <table class="table table-hover" style="border: 1px solid #dcdede;" >
          <thead class="thead-third" style="border: solid 1px #0277bd; height: 44px;">
            <tr>
              <th class="text-center col-1">
                <input type="checkbox" v-model="selectAllRightTable">
              </th>
              <th class="text-center">Nome</th>
            </tr>
          </thead>
          <tr
            v-for="usuario in usersAlreadyWithPermission"
            :key="usuario.id"
          >
            <td
              v-if="allSelectedRightTable"
              class="text-center col-1"
            >
              <input
                v-model="allSelectedRightTable"
                type="checkbox"
                checked
                disabled />
            </td>
            <td
              v-else
              class="text-center col-1"
            >
              <input
                v-model="selectedUserListRightTable"
                :value="usuario.id"
                type="checkbox" />
            </td>
            <td class="text-center">{{usuario.username}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

import { loading } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'

export default {
  name: 'GroupsTable',
  props: {
    idFuncionarios: {
      type: Set,
      default: () => new Set()
    }
  },
  data () {
    return {
      usersList: [],
      usersAlreadyWithPermission: [],
      selectedUserListLeftTable: [],
      selectedUserListRightTable: [],
      allSelectedLeftTable: false,
      allSelectedRightTable: false
    }
  },
  computed: {
    selectAllLeftTable: {
      get: function () {
        return this.allSelectedLeftTable
      },
      set: function () {
        if (this.allSelectedLeftTable) {
          this.allSelectedLeftTable = false
        } else {
          this.allSelectedLeftTable = true
        }
      }
    },
    selectAllRightTable: {
      get: function () {
        return this.allSelectedRightTable
      },
      set: function () {
        if (this.allSelectedRightTable) {
          this.allSelectedRightTable = false
        } else {
          this.allSelectedRightTable = true
        }
      }
    }
  },
  created () {
    this.loadAccounts()
  },
  methods: {
    moveToLeft () {
      if (this.selectAllRightTable) {
        this.usersList.push(...this.usersAlreadyWithPermission.splice(0, this.usersAlreadyWithPermission.length))
        this.selectAllRightTable = false
        return
      }
      this.selectedUserListRightTable.forEach(x => {
        let pos = this.usersAlreadyWithPermission.findIndex(k => k.id === x)
        let item = this.usersAlreadyWithPermission.splice(pos, 1)
        this.usersList.push(item[0])
      })
      this.selectedUserListRightTable = []

      this.updateGroupList()
    },
    moveToRight () {
      if (this.selectAllLeftTable) {
        this.usersAlreadyWithPermission.push(...this.usersList.splice(0, this.usersList.length))
        this.selectAllLeftTable = false
        return
      }
      this.selectedUserListLeftTable.forEach(x => {
        let pos = this.usersList.findIndex(k => k.id === x)
        let item = this.usersList.splice(pos, 1)
        this.usersAlreadyWithPermission.push(item[0])
      })
      this.selectedUserListLeftTable = []

      this.updateGroupList()
    },
    updateGroupList () {
      this.$emit('UpdateGroupList', this.usersList, this.usersAlreadyWithPermission)
    },
    loadAccounts () {
      loading.push()
      AccountRepository.GetAll()
        .then((response) => {
          response.data.content.forEach((x) => {
            if (this.idFuncionarios.has(x.id)) {
              this.usersAlreadyWithPermission.push(x)
              return
            }
            this.usersList.push(x)
          })
          this.updateGroupList()
          loading.pop()
        })
    },
    setEmployeesAlreadyWithPermission (idFuncionarios) {
      this.usersList.map((x) => {
        if (idFuncionarios.has(x.id)) {
          this.usersAlreadyWithPermission.push(x)
          return
        }
        return x
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/group/components/usersTable/userstable.vue